import { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

// El técnico no tiene Dashboard ni el resto de secciones administrativas — su página
// de entrada siempre es Obra, nunca Dashboard.
export const homeRouteFor = (rol) => rol === 'tecnico' ? '/obra' : '/dashboard';
export const TECNICO_ALLOWED_ROUTES = ['/agenda', '/calculadora', '/obra', '/perfil'];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        api.get('/auth/me')
          .then(res => setUser(res.data.user))
          .catch(err => {
            // Solo cerramos sesión si el servidor rechazó el token (401). Si falló
            // por falta de conexión (sin respuesta del servidor), seguimos con la
            // sesión guardada localmente para poder usar la app sin internet.
            if (err.response?.status === 401) logout();
          })
          .finally(() => setLoading(false));
      } catch { setLoading(false); }
    } else { setLoading(false); }
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  // admin, master, gerente_financiera y gerente_proyectos tienen acceso al panel admin
  const isAdmin = ['admin', 'master', 'gerente_financiera', 'gerente_proyectos'].includes(user?.rol);
  const isMaster = user?.rol === 'master';
  const isGerenteFinanciera = user?.rol === 'gerente_financiera';
  const isGerenteProyectos = user?.rol === 'gerente_proyectos';

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin, isMaster, isGerenteFinanciera, isGerenteProyectos }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return ctx;
};
